export default __webpack_public_path__ + "static/media/6.f6b65082.png";